export default {
      id: "oc-res-policydefinition-usage",
      viewBox: "0 0 1080 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-policydefinition",
      toString: function () {
        return this.url;
      }
    }